import axios from 'axios';
import HTTP_GESCOM from '@/api/HTTP_GESCOM';
import config from '@/api/config/config';
import { mapAuthenticationResponse, mapUserResponse } from '@/mapping/login.mapping';


export async function login(site, email, password) {
  const configuration = {};

  // Récupération du tenantId si site fourni
  if (site) {
    const responseTenant = await axios.post(
      config.URL_SERVEUR + 'services/app/Account/IsTenantAvailable',
      { tenancyName: site }
    );
    if (!responseTenant.data.success || responseTenant.data.result.tenantId) {
      configuration.headers = {
        'Abp.TenantId': responseTenant.data.result.tenantId
      };
    }
  }

  // Authentification via GESCOM
  const idConnexion = {
    usernameOrEmailAddress: email,
    password: password
  };

  const response = await axios.post(
    config.URL_SERVEUR + 'TokenAuth/Authenticate',
    idConnexion,
    configuration
  );

  // Application du mapping
  const mappedResponse = {
    ...response,
    data: mapAuthenticationResponse(response),
  };

  return mappedResponse;
}

export async function getUser(email) {
  const response = await HTTP_GESCOM.get('commun/Utilisateur/GetByUserName', {
    params: { userId: email }
  });
  const mappedResponse = {
    ...response,
    data: mapUserResponse(response)
  };

  return mappedResponse;
}
